import GaIconPaths from 'assets/data/icomoon-selection.json';

const iconSetData = GaIconPaths.icons.map((icon) => icon.properties.name);

export default iconSetData;
